var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEthBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20.9399C15.5417 20.9399 20 16.4816 20 10.9399C20 5.39824 15.5417 0.939941 10 0.939941C4.4583 0.939941 0 5.39824 0 10.9399C0 16.4816 4.4583 20.9399 10 20.9399ZM6.02161 10.9399L6.02148 10.9399L6.02153 10.9399L6.02148 10.9399L6.02157 10.9398L10.0009 5.43994L13.9803 10.9398L13.9804 10.9399L13.9803 10.9399L13.9804 10.9399L13.9803 10.9399L10.0009 12.5513L6.02161 10.9399ZM10.0009 13.4479L6.02148 11.6387L10.0009 16.4399L13.9804 11.6387L10.0009 13.4479Z",
    fill: "#7FFAE2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthBlue);
export default __webpack_public_path__ + "static/media/eth-blue.5041ff7ccf1a9045191b6613b8de29f7.svg";
export { ForwardRef as ReactComponent };